import { useQuery } from "@tanstack/react-query"

import { useApiContext } from "@/hooks/api/use-api-context"
import { useBookId } from "@/hooks/use-book-id"

import { fetchEmailSnippets } from "./api"

export function useFetchEmailSnippets(options?: { enabled?: boolean; scope?: "company" | "book" }) {
  const getContext = useApiContext()
  const bookId = useBookId()
  const scope = options?.scope ?? (bookId ? "book" : "company")
  const scopeSegment = scope === "company" ? "company" : bookId

  const queryKey = ["email-snippets", scopeSegment]

  return useQuery({
    queryKey,
    queryFn: async () => {
      const context = await getContext()
      if (!context) throw new Error("No context found")
      return fetchEmailSnippets(context, { scope })
    },
    enabled: options?.enabled ?? true,
    retry: false,
  })
}
